import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthService } from '@fleet-beat/shared';
import { MessageTypeEnum, SnackbarService } from '@fleet-beat/core';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private snackbarService: SnackbarService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        error: (errorResponse: HttpErrorResponse) => {
          if (errorResponse.status === 401) {
            // NOTE Unauthorized
            if (req.url.includes('/external/tracking-info')) {
              this.snackbarService.show({
                type: MessageTypeEnum.ERROR,
                message: errorResponse.error?.message || errorResponse.message,
              });
              return;
            }
            this.snackbarService.show({
              type: MessageTypeEnum.ERROR,
              message: errorResponse.error?.message || errorResponse.message,
            });

            if (
              errorResponse.error?.message !== 'Account is not active' &&
              errorResponse.error?.message !== 'Wrong password' &&
              errorResponse.error?.message !== 'Invalid credentials'
            ) {
              this.authService.signOut();
            }
          }
        },
      }),
    );
  }
}
